import { render, staticRenderFns } from "./ProductCardProductPage.vue?vue&type=template&id=11e34bd6&scoped=true&"
import script from "./ProductCardProductPage.vue?vue&type=script&lang=js&"
export * from "./ProductCardProductPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardProductPage.vue?vue&type=style&index=0&id=11e34bd6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e34bd6",
  null
  
)

export default component.exports